// extracted by mini-css-extract-plugin
module.exports = {"container":"RulesetList_container__2FUGb","border":"RulesetList_border__3Yoxf","paginationContainer":"RulesetList_paginationContainer__30oyX"};